<template>
  <div>
    <div class="row">
      <spinner v-if="loading"></spinner>
      <form v-else data-vv-scope="referral-confirmation">
        <div class="col-md-5">
          <shortcodes-editor
            v-model="data.formConfirmation"
            label="Confirmation text"
            name="content"
            validation-scope="referral-confirmation"
            validators="required"
            rows="20"
            :shortcodes="Object.keys(shortcodes)"
          />
        </div>
        <div class="col-md-7">
          Preview:
          <div class="sent-message-container">
            <div class="sent-message">
                <p v-html="renderedContent"></p>
                <a @click.prevent class="btn green">Create New Referral</a>
                <a @click.prevent class="btn default">Download Submission</a>
            </div>
          </div>
        </div>
      </form>
    </div>
    <button class="btn green save-btn" @click.prevent="save()">Save</button>
  </div>

</template>

<script>
import {mapGetters, mapActions} from "vuex";

import Spinner from "@/components/Spinner";
import ShortcodesEditor from "@/components/forms/ShortcodesEditor";
import ImageRender from "@/components/formbuilder/render/ImageRender";
import {sanitizeHtml} from "@/utils/functions";

export default {
  components: {
    Spinner,
    ShortcodesEditor,
    ImageRender,
  },
  props: {
    formId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      urlRegex: new RegExp(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/, 'g')
    }
  },
  computed: {
    ...mapGetters({
      appUser: 'getUser',
      loading: 'referralConfirmation/getLoading',
      data: 'referralConfirmation/getConfirmation',
    }),
    renderedContent () {
      let results = sanitizeHtml(this.data.formConfirmation);

      if (results) {
        Object.entries(this.shortcodes).map(([code, value]) => {
          results = results.replaceAll(`%${code}%`, `<strong>${value}</strong>`)
        })

        results = results.replaceAll(this.urlRegex, match =>
          `<a href="${match}" target="_blank">${match}</a>`
        )
      }

      return results;
    },
    shortcodes () {
      return {
        'organization_name': this.appUser.organizations[0].name,
        'first_name': this.appUser.first_name,
        'last_name': this.appUser.first_name,
        'email': this.appUser.email,
      }
    },
  },
  methods: {
    async save() {
      if (await this.$validator.validateAll('referral-confirmation')) {
        this.saveConfirmation({
          formId: this.formId,
          ...this.data
        }).then(() => {
          this.$notify('Changes saved!');
        });
      }
    },
    ...mapActions({
      fetchConfirmation: 'referralConfirmation/fetchConfirmation',
      saveConfirmation: 'referralConfirmation/saveConfirmation',
    }),
  },
  mounted() {
    this.fetchConfirmation({formId: this.formId});
  }
}
</script>

<style lang="scss" scoped>

.sent-message-container {
  position: relative;
  height: 480px;
  width: 100%;
  text-align: center;
}

.sent-message {
  font-size: 1.4em;
  text-align: center;
  position: absolute;
  top: 50%;
  margin-top: -85px;
  width: 100%;

  p {
    margin-bottom: 60px;
  }
}

.save-btn {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// ReferralConfirmation.vue?01ad0145